import type {StaticConfigurationProvider} from './StaticConfigurationProvider';

export default class StaticConfigurationProviderImpl
  implements StaticConfigurationProvider
{
  public readonly configuration;

  constructor() {
    this.configuration = {
      graphqlApiLocator: throwIfUndefined(
        process.env.EXPO_PUBLIC_GRAPHQL_API_URL,
      ),
    };
  }
}

function throwIfUndefined<T>(_: T | undefined, hint = 'unknown'): T {
  if (_ === undefined) {
    throw new Error(`Value cannot be undefined: ${hint}`);
  }
  return _;
}
